import { useWsmFitmentAxisCreateMutation, WsmFitmentValueKind } from "@dashboard/graphql";
import useNavigator from "@dashboard/hooks/useNavigator";
import useNotifier from "@dashboard/hooks/useNotifier";
import { commonMessages } from "@dashboard/intl";
import React from "react";
import { useIntl } from "react-intl";

import { addToWsmFitmentList } from "../cache";
import WsmFitmentNamedDetailsPage from "../components/WsmFitmentNamedDetailsPage";
import { useWsmFitmentAxes } from "../hooks/useWsmFitmentVocabulary";
import { axisMessages } from "../messages";
import { wsmFitmentAxisListPath, wsmFitmentAxisUrl } from "../urls";
import { getWriteState } from "../utils";

export const WsmFitmentAxisCreateView = () => {
  const intl = useIntl();
  const navigate = useNavigator();
  const notify = useNotifier();

  // Mounted so the refetch below reaches it: refetch-by-name skips an unmounted query.
  useWsmFitmentAxes();

  const [createAxis, createAxisOpts] = useWsmFitmentAxisCreateMutation({
    // Payload errors render on the form; a toast would say them twice.
    disableNestedErrorHandling: true,
    // The detail screen reads its row from the list: put it there before navigating.
    update: (cache, { data }) => {
      const axis = data?.wsmFitmentAxisCreate?.axis;

      if (axis && !data?.wsmFitmentAxisCreate?.errors.length) {
        addToWsmFitmentList(cache, "wsmFitmentAxes", axis);
      }
    },
    refetchQueries: ["WsmFitmentAxes"],
    awaitRefetchQueries: true,
    onCompleted: result => {
      const axis = result.wsmFitmentAxisCreate?.axis;

      if (axis && !result.wsmFitmentAxisCreate?.errors.length) {
        notify({ status: "success", text: intl.formatMessage(commonMessages.savedChanges) });
        navigate(wsmFitmentAxisUrl(axis.id));
      }
    },
  });
  const payload = createAxisOpts.data?.wsmFitmentAxisCreate;

  return (
    <WsmFitmentNamedDetailsPage
      title={intl.formatMessage(axisMessages.create)}
      backHref={wsmFitmentAxisListPath}
      withValueKind
      initialData={{ name: "", displayLabel: "", valueKind: WsmFitmentValueKind.TEXT }}
      errors={payload?.errors ?? []}
      disabled={createAxisOpts.loading}
      saveButtonBarState={getWriteState(createAxisOpts, payload)}
      onSubmit={data =>
        createAxis({
          variables: {
            input: {
              name: data.name.trim(),
              displayLabel: data.displayLabel.trim(),
              valueKind: data.valueKind,
            },
          },
        })
      }
    />
  );
};

export default WsmFitmentAxisCreateView;
